<template>
  <div>
    <!-- 레이어 팝업 -->
    <DownloadPopup
      v-if="downloadLayout"
      :contenttype="downloadContentType"
      :contentInfo="contentInfo"
      :contentid="downloadContentId"
      :close="closeDownloadLayout"
    />
    <PopupShare
      v-if="shareLayout"
      :title="contentInfo.title"
      :id="movieid"
      :description="contentInfo.synopsis"
      @on-click-close="closeShareLayout"
    />

    <template v-if="!isLoading">
      <main class="movie player-wrap" id="contents">
        <MoviePlayer
          v-if="hasMovieId"
          :content-info="contentInfo"
          :open-download-popup="openDownloadPopup"
          :open-share-popup="openShareLayout"
          :key="'movie_player'"
        />

        <EventBannerList
          v-if="hasEventList && !isPooqzone"
          :event-banner-list="eventBannerList"
        />

        <BottomTabContainer
          :content-info="contentInfo"
          :key="`bottom_tab_container_${$route.fullPath}`"
        />
      </main>
      <MetaInfo
        :content-info="contentInfo"
        content-type="movie"
      />
    </template>

    <div
      v-else
      class="min-h-screen"
    />
  </div>
</template>

<script>
import { parseUrl } from 'query-string'
import _ from 'lodash'
import { mapMutations } from 'vuex'
import cookie from '@/common/utils/cookie'
import { LOGIN_SUCCESS_EVENT, MENU, SET_CURRENT_MENU } from '@/common/resources/const'
import { redirectToHttps, scrollTop, destroyPlayer, contentDetailErrorCatcher } from '@/common/utils/common'
import { checkAdultContent, openAdultPopupIfNeeded } from '@/common/utils/adult'
import { getMovieContentsDetail, getEventsBannerMovie } from '@/common/utils/request'
import { autoLoginSetting } from '@/common/utils/login'
import playerPage from '@/mixins/player.page.mixin'
import MoviePlayer from '@/components/player/MoviePlayer'
import DownloadPopup from '@/components/player/PopupDownload'
import PopupShare from '@/components/player/PopupShare'
import MetaInfo from '@/components/meta/Meta'
import BottomTabContainer from '@/components/player/BottomTabContainer'
import EventBannerList from '@/components/player/EventBannerList'

export default {
  name: 'Movie',
  mixins: [
    playerPage
  ],
  components: {
    MoviePlayer,
    DownloadPopup,
    PopupShare,
    MetaInfo,
    BottomTabContainer,
    EventBannerList
  },
  data () {
    return {
      isLoading: true,
      type: 'movie',
      movieid: '',
      contentInfo: {},
      voucherList: [], // 이용권 데이터
      dataTheme: undefined, // 연관 테마 데이터
      isVoucherShow: false, // 이용권 더보기 상태인지 여부
      isPooqzone: cookie.isWavveOn(),
      eventBannerList: [],
      ogUrl: window.location.protocol + '//' + window.location.host + window.location.pathname + window.location.search // stream player mixin 이 빠지면서 필요한 데이터 추가
    }
  },
  computed: {
    hasMovieId () {
      return _.get(this.contentInfo, 'movieid', '') !== null
    },
    hasEventList () {
      return this.eventBannerList.length > 0
    }
  },
  methods: {
    get: _.get,
    ...mapMutations(['showLoginPopup', SET_CURRENT_MENU]),
    errorCatcher (e) {
      console.error(e)
      contentDetailErrorCatcher.bind(this)
    },
    setContentDownloadData (movieData) {
      this.downloadContentId = _.get(movieData, 'movieid', '')
      this.downloadContentType = 'movie'
    },
    setMoviePPVData (movieData) {
      const movieMarkList = _.get(movieData, 'moviemarks', [])
      const isPPV = movieMarkList.indexOf('won') > -1
      this.updateCurrentMenu(isPPV ? MENU.MOVIE_18 : MENU.MOVIE)
    },
    async setData () {
      this.isLoading = true

      // set movie data
      try {
        const { data } = await getMovieContentsDetail({ movieid: this.movieid })
        const { isAdultVerified } = await checkAdultContent(data)
        await openAdultPopupIfNeeded({ isAdultVerified })
        this.setContentDownloadData(data)
        this.setMoviePPVData(data)
        this.contentInfo = data
        this.isLoading = !isAdultVerified
      } catch (e) {
        this.errorCatcher(e)
      }

      // set movie banner
      try {
        const { data } = await getEventsBannerMovie({ movieid: this.movieid })
        this.eventBannerList = data?.list ?? []
      } catch (error) { console.error(error) }
    },
    initialize () {
      const { query } = parseUrl(location.href)
      this.movieid = _.get(query, 'movieid', '')
    },
    updateCurrentMenu (menuName) {
      this[SET_CURRENT_MENU](menuName)
    },
    postMessage (e) {
      if (e.origin === location.origin && e.data === 'voucherAutoLogin') {
        const credential = cookie.getCredential()
        const isMultiLine = Number(cookie.userInfo('profilecount')) !== 1
        autoLoginSetting(credential, isMultiLine).then(() => {
          location.reload()
        })
      }
    }
  },
  created () {
    window.addEventListener('message', this.postMessage)
    scrollTop()
    redirectToHttps()
    this.initialize()
    this.setData()
  },
  mounted () {
    this.$events.$off(LOGIN_SUCCESS_EVENT)
  },
  beforeDestroy () {
    destroyPlayer()
    window.removeEventListener('message', this.postMessage)
  },
  watch: {
    $route (n, o) {
      this.initialize()
      this.setData()
      const newMovieId = _.get(n, ['query', 'movieid'], '')
      const oldMovieId = _.get(o, ['query', 'movieid'], '')
      if (newMovieId !== oldMovieId) {
        scrollTop()
      } else {
        scrollTop()
      }
    }
  }
}
</script>
<style lang="scss" src="@/assets/scss/category/movie.scss" />
